import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n'
import Button from '../../UI/Buttons/Button';
import usePageTitle from '../../../Hooks/usePageTitle';
import useBodyClass from '../../../Hooks/useBodyClass';
import { OrderCancellation } from './OrderCancellation';
import { ConfirmCancellation } from './ConfirmCancellation';
import { APIPost } from '../../API/APIRequest';
import { useParams } from 'react-router';
import { GenericErrorBox } from '../../UI/ErrorBox/GenericErrorBox';
import { Cancelation } from './Cancelation';
import CancelationReasons from './CancelationReasons';
import { useSearchParams } from 'react-router-dom';

export function StandardCancellation(props) {
    const { t, i18n } = useTranslation();
    const {setErrors, showCancellationForm} = props;
    const [cancellationConfirmed, setCancellationConfirmed] = useState(false);
    const [endDate, setEndDate] = useState("");
    const [orderId, setOrderId] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(showCancellationForm ? "CANCELLATION_REASONS" : "ORDER_CANCELLATION");
    const [surveyData, setSurveyData] = useState({});

    const { fid } = useParams();

    const updateQuery = (param) => {
        setSearchParams({ step: param })

    }

    const handlePageChange = (pageName) => {
        setCurrentPage(pageName);
        updateQuery(pageName?.toLowerCase());
    }

    useEffect(() => {
        const step = searchParams.get("step");

        if (step) {
            setCurrentPage(step.toUpperCase())
        }

    }, [searchParams])


    const formatDate = (dateStr) => {
        if (!dateStr) return "";
      
        const date = new Date(dateStr);
      
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
      
        return `${day}/${month}/${year}`;
      };

    const handleCancellation = () => {
    
        const payload = {
            fid,
            ReasonId: surveyData?.reasons ?? "0",
            Comment: surveyData?.suggestions ?? "No Comment Given",
          };

        APIPost({

            "controller": "order",
            "action": "cancelsub",
            "data": payload,
            "content_type": "json"

        })
            .then((response) => {
               
                setUserEmail(response?.data?.email);
                handlePageChange("CONFIRM_CANCELLATION");

            }).catch((error) => {

                let err = error.response?.data?.errors;
 
                if (err?.length > 0 && err.includes("error.cancelsubscriptiondonebutemailfailed")) {
                   handlePageChange("CONFIRM_CANCELLATION"); 
 
                } else {
 
                    var unexpected = [];
                    unexpected.push("error.unexpected");
                    setErrors(unexpected);
                    console.log("An error occured while cancelling the subscription")
                }
            })
    }

    const handleRedirection = () => {
        let returnUrl = sessionStorage.getItem("ReturnUrl");
        window.location.href = returnUrl;
    }


    return (
            <>
                {currentPage === "CANCELLATION_REASONS" && (<CancelationReasons 
                handlePageChange={handlePageChange} 
                onDataChange={(data)=>setSurveyData(data)}/>)}

                {currentPage === "ORDER_CANCELLATION" && (<OrderCancellation setCancellationConfirmed={setCancellationConfirmed} 
                setEndDateParent={setEndDate} 
                formatDateParent={formatDate} 
                setOrderIdParent={setOrderId} 
                handleCancellation={handleCancellation} 
                handleRedirection={handleRedirection} 
                handlePageChange={handlePageChange} />)}

                {currentPage === "CONFIRM_CANCELLATION" && (<ConfirmCancellation 
                handleRedirection={handleRedirection} 
                endDate={endDate} 
                orderId={orderId} 
                userEmail={userEmail}  />)}
            </>
        

    );
}